import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.7" }, [
      _createElementVNode("rect", {
        width: "14",
        height: "2",
        rx: "1",
        transform: "matrix(0.707107 0.707106 -0.707107 0.707106 2.75732 1.84375)",
        fill: "white"
      }),
      _createElementVNode("rect", {
        width: "14",
        height: "2",
        rx: "1",
        transform: "matrix(-0.707108 0.707106 -0.707107 -0.707106 12.6567 3.25781)",
        fill: "white"
      })
    ], -1)
  ]))]))
}
export default { render: render }